
<template>
    <div class="main" :required="required">
        <label data-bs-toggle="tooltip" :title="tooltip" :for="forId"><slot/></label>
        <div v-show="required" class="required">
            <fa-icon icon="asterisk" />
        </div>
    </div>
</template>

<style scoped lang="scss">
    label {
        width: auto;
        font-weight: bold;
    }
    .required {
        margin-left: .3rem;
        display: inline-block;
    }
    svg {
        color: var(--bs-danger);
        font-size:smaller;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    name: "FormLabel",
    props: {
        required: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: ""
        },
        forId: {
            type: String,
            default: ""
        }
    }
});

</script>
